<template>
  <v-row>
    <v-col md="2" sm="4" cols="12">
      <dynamics-indicator-item
        title="Выручка"
        tooltip-text="Выручка из коннекторов за выбранный период"
        icon="/img/stat/icons/cashier.svg"
        value-type="amount"
        :indicator-data="indicators.revenue"
        :loading="loading"
      />
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <dynamics-indicator-item
        title="Заказов"
        tooltip-text="Кол-во заказов из коннекторов в сравнении с прошлым периодом"
        icon="/img/stat/icons/bag.svg"
        value-type="count"
        :indicator-data="indicators.ordersCount"
        :loading="loading"
      />
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <dynamics-indicator-item
        title="Средний чек"
        tooltip-text="Средний чек в сравнении с прошлым периодом"
        icon="/img/stat/icons/receipt.svg"
        value-type="amount"
        :indicator-data="indicators.avgBill"
        :loading="loading"
      />
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <dynamics-indicator-item
        title="Доставка"
        tooltip-text="Выручка с заказов курьерами агрегаторов"
        icon="/img/stat/icons/man.svg"
        value-type="amount"
        :indicator-data="indicators.aggregatorDeliveryRevenue"
        :loading="loading"
      />
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <dynamics-indicator-item
        title="Свои курьеры"
        tooltip-text="Выручка с заказов коннекторов, доставленных собственными курьерами"
        icon="/img/stat/icons/reverse-man.svg"
        value-type="amount"
        :indicator-data="indicators.deliveryRevenue"
        :loading="loading"
      />
    </v-col>
    <v-col md="2" sm="4" cols="12">
      <dynamics-indicator-item
        title="Самовывоз"
        tooltip-text="Выручка коннекторов по самовывозу"
        icon="/img/stat/icons/dish.svg"
        value-type="amount"
        :indicator-data="indicators.pickupRevenue"
        :loading="loading"
      />
    </v-col>
  </v-row>
</template>

<script>
  import DynamicsIndicatorItem from '@/components/stat/revenue/DynamicsIndicatorItem.vue'

  export default {
    name: 'ConnectorDynamicsIndicatorsList',
    components: { DynamicsIndicatorItem },
    props: {
      indicators: {
        type: Object,
        default: () => ({}),
      },
      loading: {
        type: Boolean,
        default: false,
      },
    },
  }
</script>
